import { useCompanyForm } from 'pages/organisations/companies/v5/hooks/useCompanyForm';
import { FORM_FIELD_PATHS } from '../../constants';
import WholesalerMultiSelectField from './WholesalerMultiSelectField';

const RegionsMultiSelect = ({ darkMode }) => {
    const { formData } = useCompanyForm();

    return (
        <WholesalerMultiSelectField
            darkMode={darkMode}
            endpoint={`/wholesaler/${formData?.id}/regions/all`}
            fieldPath={FORM_FIELD_PATHS.REGIONS}
            label="Regions"
            placeholder="- Select Regions -"
            tooltip="Select one or more regions."
        />
    );
};

export default RegionsMultiSelect;
